import { useIntl } from 'react-intl';
import { Page } from '../../../../components/page/Page';
import { AuditIcon } from '../../components/AuditIcon';
import { AuditConfigForm } from './form';

/**
 * Admin page for audit materials exclusions (excluded custom IDs).
 */
export function AuditMaterialsPage() {
  const { $t } = useIntl();
  const title = $t({
    id: 'audit.auditConfig.materials',
    defaultMessage: 'Materiales',
  });

  return (
    <Page htmlTitle={title}>
      <Page.Header icon={<AuditIcon />} title={title} />
      <Page.Content>
        <AuditConfigForm />
      </Page.Content>
    </Page>
  );
}
